<template>
    <div class="part_wrap">
        <div class="part_title">
            <span class="title">
                <label class="check_wrap">
                    <input type="checkbox" v-model="department.isSelected" @change="action_selectDepartment" />
                    <span class="checkmark"></span>
                    {{ department.title }}
                </label>
            </span>
            <v-icon class="mgl_auto" @click="action_onChangeEmployeesListShown">{{ isEmployeesListOpened ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
        </div>
        <ul class="part_list" v-if="isEmployeesListOpened && !!employees.length">
            <EmployeeItem
                v-show="isEmployeesListOpened"
                v-for="employee in employees"
                :key="employee._id"
                :employee="employee"
                :handle_departmentUpdate="handle_departmentUpdate"
            />
        </ul>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { useManagingWorkers } from '@/composables/use-managing-workers'
import EmployeeItem from './EmployeeItem.vue'

export default {
    setup() {
        // 구 ManagingDataController 대체 — 이름 충돌 방지를 위해 allEmployees 로 노출
        const { employees: allEmployees, updateDepartmentsSelection, updateEmployeesSelection } = useManagingWorkers()
        return { allEmployees, updateDepartmentsSelection, updateEmployeesSelection }
    },
    components: {
        EmployeeItem
    },
    data() {
        return {
            isEmployeesListOpened: true
        }
    },
    props: {
        department: {
            type: Object,
            required: true
        }
    },
    methods: {
        handle_departmentUpdate() {
            let _department = deepCopy(this.department)
            let _employees = deepCopy(this.employees)

            const isAllEmployeesSelectedOrNot = _employees.filter((employee) => employee.departmentID._id === _department._id).every((employee) => employee.isSelected)

            _department.isSelected = isAllEmployeesSelectedOrNot

            this.updateDepartmentsSelection([_department])
        },

        action_onChangeEmployeesListShown() {
            this.isEmployeesListOpened = !this.isEmployeesListOpened
        },

        action_selectDepartment() {
            let _department = deepCopy(this.department)
            this.updateDepartmentsSelection([_department])

            this.updateEmployeesSelection(
                this.employees.map((employee) => ({
                    ...employee,
                    isSelected: _department.isSelected
                }))
            )
        }
    },
    computed: {
        employees() {
            let _employees = deepCopy(this.allEmployees)

            return _employees.filter((employee) => employee.departmentID._id === this.department._id)
        }
    }
}
</script>

<style lang="scss" scoped></style>
